import React from "react";
import { createPortal } from "react-dom";
import "./ApplicationSentModal.css";

export default function ApplicationSentModal({
  isOpen = true,
  onClose,
  onUnlockMoreJobs,
}) {
  if (!isOpen) return null;
  if (typeof document === "undefined") return null;

  const handleOverlayClick = (e) => {
    e.stopPropagation();
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return createPortal(
    <div className="asm-overlay" onClick={handleOverlayClick}>
      <div className="asm-modal" role="dialog" aria-modal="true">
        <button
          type="button"
          className="asm-close"
          onClick={onClose}
          aria-label="Close"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M4.667 4.667L11.333 11.333M11.333 4.667L4.667 11.333"
              stroke="#023047"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </button>

        <div className="asm-icon" aria-hidden="true">
          <div className="asm-envelope">
            <div className="asm-envelope-top" />
            <div className="asm-envelope-body" />
            <div className="asm-arrow" />
          </div>
        </div>

        <h2 className="asm-title">Application Sent!</h2>

        <p className="asm-text">
          Your application has been sent to the hirer. They'll review your
          profile and get back to you soon.
        </p>

        <button type="button" className="asm-cta" onClick={onUnlockMoreJobs}>
          Unlock More Job Opportunities
        </button>
      </div>
    </div>,
    document.body
  );
}
